<template>
  <div id="event-live-chat">
    <div class="event-live-chat--flame--chat">
      <template v-for="(comment, index) in comments">
        <template v-if="isDispChat && (comment.isBlock == false || comment.uId == userid || isorganizer == true)">
          <div :class="{'event-live-chat--opacity__right': comment.isBlock == true && comment.uId != userid}" class="event-live-chat--section--chat--row">
            <template v-if="comment.avatar != 'undefined' && comment.avatar != '' ">
              <img v-bind:src="comment.avatar" class="event-live-chat--image__circle">
            </template>
            <template v-else>
              <img v-bind:src="require('assets/images/person_shadow_gray')" class="event-live-chat--image__circle">
            </template>
            <div class="event-live-chat--section--label">
              <p class="event-live-chat--label__black__little">{{comment.uName}}</p>
              <div class="event-live-chat--section--caht_body">
                <template v-if="0 > comment.body.indexOf('https://')">
                  <p class="event-live-chat--label__gray">{{comment.body}}</p>
                </template>
                <template v-else>
                  <a class="event-live-chat--label__gray event-live-chat--label__link_blue" v-bind:href="comment.body" target="_blank">{{comment.body}}</a>
                </template>
                <p class="event-live-chat--label__no_disp__created_date" style="display: none;">{{formatDate(comment.createdAt)}}</p>
                <template v-if="isorganizer">
                    <img v-on:click="commentDelete(comment.id)" v-bind:src="require('assets/images/dust_icon_black')" class="event-live-chat--image__square" title="コメントを削除">
                    <img v-on:click="commentBlock(comment.uId, comment.isBlock)" v-bind:src="require('assets/images/forbidden_mark_black')" class="event-live-chat--image__square" title="コメントをブロック">
                </template>
              </div>
            </div>
            <br>
          </div>
        </template>
      </template>
      <div class="event-live-chat__only_sp"></div>
      <div class="event-live-chat--flame--buttons">
        <form v-on:submit.prevent="onSubmit" class="event-live-chat--form">
          <div style="padding-top: 5px;">
            <template v-if="uimage != 'undefined' && uimage != '' ">
              <img v-bind:src="uimage" class="event-live-chat--image__circle">
            </template>
            <template v-else>
              <img v-bind:src="require('assets/images/person_shadow_gray')" class="event-live-chat--image__circle">
            </template>
          </div>
          <div style="z-index: 1;">
            <input type="text" name="body" class="event-live-chat--input" maxlength="140" v-bind:placeholder="chatPlaceholder" v-model="inputForm.body" @blur="onBlurChat">
          </div>
          <div>
            <button v-on:click="speak" v-bind:disabled="inputForm.body == null || 1 > inputForm.body.trim().length" class="event-live-chat--button__gray">投稿</button>
          </div>
        </form>
        <div class="event-live-chat--button__chat_disp--wrap event-live-chat__only_pc" v-on:click="livechatDisp">
          <span class="event-live-chat--button__chat_disp--label">ライブチャット非表示 ∧ </span>
        </div>
      </div>
      <div class="event-live-chat--dummy_scroll_ctrl event-live-chat__only_pc" style="height: 70px;"></div>
    </div>
    <div class="event-live-chat--flame--non_chat event-live-chat--button__chat_disp--wrap event-live-chat__only_pc event-live-chat--button__chat_disp--label" v-on:click="livechatNonDisp" style="display:none; margin-top: 0; background: #FFFFFF;">
      <p>ライブチャット表示 ∨ </p>
    </div>
  </div>
</template>

<script>
  import {db} from '../utils/firebase'
  import firebase from "firebase/app"
  import consts from '../utils/consts'

  export default {
    name: "EventLiveChat",
    props: {
      ttsid: { type: String, required: true },
      uimage: { type: String, required: true },
      uname: { type: String, required: true },
      isorganizer: { type: Boolean, required: true },
      userid: { type: String, required: true },
    },
    data: () => ({
      comments: [],
      uID: "",
      isDispChat: true,
      isBlocked: false,
      inputForm: {
        body: null,
      },
      contents: {
        width : 0,
        height : 0,
      }
    }),
    firestore() {
      const roomId = this.ttsid;
      const firstdoc = "start";
      (async () => {
        // roomの存在チェック
        const postRefParent = db.collection(consts.EVENT_LIVE_CHAT.PARENT_COLLECTION).doc(roomId)
        const postDocParent = await postRefParent.get()
        if (!postDocParent.exists) {
          // room生成
          await postRefParent.set({roomID: roomId},{merge: true})
        }
        // chatの存在チェック
        const postRefChild = db.collection(consts.EVENT_LIVE_CHAT.PARENT_COLLECTION).doc(roomId).collection(consts.EVENT_LIVE_CHAT.CHILD_COLLECTTION).doc(firstdoc)
        const postDocChild = await postRefChild.get()
        if (!postDocChild.exists) {
          const firstComment = db.collection(consts.EVENT_LIVE_CHAT.PARENT_COLLECTION).doc(roomId).collection(consts.EVENT_LIVE_CHAT.CHILD_COLLECTTION).doc(firstdoc)
          // チャットの生成
          await firstComment.set({
            body: "マナーを守って楽しむちげな🐾",
            avatar: "https://s3-ap-northeast-1.amazonaws.com/tiget.net/media/tiget_live_chat_1st_speak_icon.png",
            uId: "",
            uName:"TIGET公式ヘルプ みーやん",
            isBlock: false,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          })
        }
      })()

      // チャットの取得
      return {
        comments: db.collection(consts.EVENT_LIVE_CHAT.PARENT_COLLECTION).doc(roomId).collection(consts.EVENT_LIVE_CHAT.CHILD_COLLECTTION).orderBy('createdAt', 'asc')
      }
      scrollChatFlameBottom()
    },
    computed: {
      consts: function() {
        return consts
      },
      chatPlaceholder() {
        var _name = "ゲスト";
        if (this.uname.length > 0) {
          _name = this.uname
        }
        return _name + 'としてチャットを入力...'
      }
    },
    methods: {
      // チャット投稿
      speak: function(event){
        var body = this.inputForm.body
        if (1 > body.trim().length) {
          alert("1文字以上入力してください。")
          return;
        } else if (body.trim().length > 140) {
          alert("10文字以下で入力してください。")
          return;
        } else {
          db.collection(consts.EVENT_LIVE_CHAT.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_CHAT.CHILD_COLLECTTION).add({
            body: body,
            uId: this.uID,
            uName:this.uname,
            avatar: this.uimage,
            isBlock: this.isBlocked,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          })
          this.inputForm.body = ""
          scrollChatFlameBottom()
        }
        event.preventDefault()
      },
      // チャットの表示/非表示制御
      livechatDisp: function() {
        if (this.isDispChat) {
          this.isDispChat = false
          $('.event-live-chat--flame--chat').hide()
          $('.event-live-chat--flame--non_chat').show()
        } else {
          this.isDispChat = true
        }
        setCustomStyle('#event-live-chat')
      },
      livechatNonDisp: function() {
        this.isDispChat = true
        $('.event-live-chat--flame--non_chat').hide()
        $('.event-live-chat--flame--chat').show()
        $('.event-live-chat--flame--chat').css("height", $('.pg-live__container__left').find('iframe').height())
        setTimeout(function(){
          scrollChatFlameBottom()
          setCustomStyle('#event-live-chat')
        }, 200);
      },
      // コメント削除
      commentDelete: function(docId) {
        db.collection(consts.EVENT_LIVE_CHAT.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_CHAT.CHILD_COLLECTTION).doc(docId).delete()
      },
      // コメントブロック(関係者/投稿者のみ表示される)
      commentBlock: function(uId, isBlock) {
        db.collection(consts.EVENT_LIVE_CHAT.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_CHAT.CHILD_COLLECTTION).where("uId", "==", String(uId)).get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              doc.ref.update({
                isBlock: !isBlock,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
              })
            });
          })
      },
      // 日付整形(yyyy/n/d hh:mm)
      formatDate: function(date) {
        if (date == 'undefined' || date == null || date.length > 0){
          return ""
        }
        var day = date.toDate()
        return day.getFullYear() + '/' + (day.getMonth() + 1).toString().padStart(2, '0') + '/' + day.getDate().toString().padStart(2, '0') + " " + day.getHours().toString().padStart(2, '0') + ":" + day.getMinutes().toString().padStart(2, '0')
      },
      onBlurChat: function() {
        GLOBAL_SCROLL_POS = 0
      },
      // onLoadイベント
      window:onload = function() {
        scrollChatFlameBottom()
      },
    },
    watch: {
      // コメントの取得
      comments: function () {
        this.comments.forEach((val, i, array) => {
          if (val.uId == this.uID) {
            if (val.isBlock == true){
              this.isBlocked = true;
              return
            } else {
              this.isBlocked = false;
            }
          }
        });
        setTimeout(function(){
          setCustomStyle('#event-live-chat')
        }, 100);
        scrollChatFlameBottom()
      }
    },
    mounted: function () {
      // userIDの設定
      if(this.userid.length > 0){
        this.uID = this.userid
      } else {
        this.uID = Math.random().toString(36).slice(-10)
      }
      setCustomStyle('#event-live-chat')
    }
  }
</script>

<style lang="scss" scoped>
  @import '../packs/application.css';

  .event-live-chat--flame--chat {
    width: 410px;
    height: 0;
    padding: 8px;
    display: inline-block;
    position: relative;
    border: 1px solid #DCDCDC;
    overflow-y: scroll;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;

    @media screen and (max-width: 1000px) {
      border: none;
      width: auto;
    }
  }

  .event-live-chat--flame--chat::-webkit-scrollbar {
    display:none;
  }

  .event-live-chat--section--chat--row {
    width: 100%;
    margin: 10px 0;
    margin-bottom: 20px;
    display: -webkit-box;
    word-break: break-all;
  }

  .event-live-chat--image__circle {
    border-radius: 50%;
    height: 24px;
  }

  .event-live-chat--button__chat_disp--label {
    width: 410px;
    cursor: pointer;
  }

  .event-live-chat--image__square {
    cursor: pointer;
    height: 24px;
    margin-right: -5px;
    margin-top: -2px;
  }

  .event-live-chat--section--label {
    display: block;
    margin-left: 5px;
    max-width: 350px;
    line-height: 1;

    @media screen and (max-width: 1000px) {
      max-width: 95vw;
    }

    @media screen and (max-width: 680px) {
      max-width: 90vw;
    }
  }

  .event-live-chat--section--caht_body {
    display: inline-flex;
    max-width: 85vw;

    @media screen and (max-width: 1000px) {
      width: 85vw;
    }
  }


  .event-live-chat--flame--buttons {
    margin-top: -6px;
    background-color: white;

    @media screen and (max-width: 1000px) {
      margin-top: -40px;
    }
  }

  .event-live-chat--flame--buttons__scrolled {
    position: fixed;
    margin-top: 0;

    @media screen and (max-width: 1000px) {
      bottom: 10px;
    }
  }

  .event-live-chat--label__black__little {
    font-size: 10px;
    color: #999999;
  }

  .event-live-chat--label__link_blue {
    color: #4aafea !important;
  }

  .event-live-chat--label__gray {
    font-size: 13px;
    margin-top: 5px;
    color: #666666;
  }

  .event-live-chat--form {
    display: inline-flex;
    font-size: 14px;

    @media screen and (max-width: 1000px) {
      font-size: 16px;
    }
  }

  .event-live-chat--input {
    width: 290px;
    max-width: 75vw;
    height: 40px;
    padding-left: 8px;
    margin-left: 8px;
    background: #FAFAFA;
    border: 1px solid #DCDCDC;

    @media screen and (max-width: 1000px) {
      max-width: 70vw;
      width: 660px;
    }

    @media screen and (max-width: 650px) {
      max-width: 63vw;
      width: 600px;
    }

    @media screen and (max-width: 400px) {
      width: 250px;
    }

    @media screen and (max-width: 350px) {
      width: 200px;
    }
  }

  .event-live-chat--button__gray {
    height: 40px;
    width: 65px;
    max-width: 15vw;
    background-color: #666666;
    color: #FFFFFF;
    border: none;
    margin-left: 10px;
    white-space: nowrap;

    @media screen and (max-width: 1000px) {
      max-width: 25vw;
      width: 20vw;
    }
    @media screen and (max-width: 400px) {
      width: 15vw;
    }
  }

  .event-live-chat--flame--non_chat {
    border: 1px solid #DCDCDC;
    height: 62px;
    padding-left: 8px;
    background: #FAFAFA;
    border: 1px solid #DCDCDC;
    padding-top: 20px;
  }

  .event-live-chat--button__gray:disabled {
    opacity: 0.5;
  }

  .event-live-chat--button__chat_disp--wrap{
    color: #666666;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 11.5px;
  }

  .event-live-chat--opacity__right {
    opacity: 0.5;
  }

  .event-live-chat__only_pc {
    @media screen and (max-width: 1000px) {
      display: none;
    }
  }

  .event-live-chat__only_sp {
    height: 30px;
    display: none;

    @media screen and (max-width: 1000px) {
      display: block;
    }
  }

</style>
